import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    // 用catch捕获重复跳转的错误，避免控制台警告
    return originalPush.call(this, location).catch((err) => {
        // 只忽略"重复导航"的错误，其他错误正常抛出
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('../views/index.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login.vue'),
    },
    {
        path: '/questionnaire',
        name: 'questionnaire',
        component: () => import('../views/questionnaire.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/questionnaire/new',
        name: 'questionnaire-new',
        component: () => import('../views/questionnaireNew.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/questionnaire/psqi',
        name: 'questionnaire-psqi',
        component: () => import('../views/questionnairePsqi.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/questionnaire/scale/:scaleId',
        name: 'scale-questionnaire',
        component: () => import('../views/scaleQuestionnaire.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/questionnaire/answer/:answerId',
        name: 'scale-answer-detail',
        component: () => import('../views/scaleAnswerDetail.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/sleep-log',
        name: 'sleep-log',
        component: () => import('../views/sleepLog.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/profile.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/devices',
        name: 'devices',
        component: () => import('../views/devices.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/devices/:deviceId',
        name: 'device-detail',
        component: () => import('../views/deviceDetail.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/devices/:deviceId/monitor/:date?',
        name: 'monitor-record',
        component: () => import('../views/monitorRecord.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/sleep-science',
        name: 'sleep-science',
        component: () => import('../views/contentList.vue'),
    },
    {
        path: '/sleep-science/:id',
        name: 'sleep-science-detail',
        component: () => import('../views/contentDetail.vue'),
    },
    {
        path: '/training-videos',
        name: 'training-videos',
        component: () => import('../views/contentList.vue'),
    },
    {
        path: '/training-videos/:id',
        name: 'training-videos-detail',
        component: () => import('../views/contentDetail.vue'),
    },
    {
        path: '/account-unconfigured',
        name: 'account-unconfigured',
        component: () => import('../views/accountUnconfigured.vue'),
    },
    // {
    //   path: "/about",
    //   name: "about",
    //   component: () => import("../views/AboutView.vue"),
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
})

export default router

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated

    if (to.meta.requiresAuth && !isAuthenticated) {
        next({ name: 'login', query: { redirect: to.fullPath } })
        return
    }

    if (to.name === 'login' && isAuthenticated) {
        const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/'
        next(redirect)
        return
    }

    next()
})
